import { render } from "./TheModal.vue?vue&type=template&id=57907228"
import script from "./TheModal.vue?vue&type=script&lang=js"
export * from "./TheModal.vue?vue&type=script&lang=js"
script.render = render

export default script